<div *ngIf="age$ | async as age"><strong>Age: </strong> {{ age }}</div>
